export function rfqWidget() {
  function init() {
    window.addEventListener(
      "message",
      function (evt) {
        if (evt?.data?.eventName === "sqlEvent") {
          dataLayer.push(evt?.data?.sqlEvent);
        }
      },
      false
    );
  }

  return {
    init,
  };
}
